import React from 'react';
import { Outlet } from 'react-router-dom';
import { motion } from 'framer-motion';
import { SidebarAnimated } from './SidebarAnimated';
import { Header } from './Header';
import { useLayout } from '../../contexts/LayoutContext';
import MSNMessenger from '../messenger/MSNMessenger';
import '../../styles/modern-design.css';

export const Layout: React.FC = () => {
  const { isMobile } = useLayout();

  // Termin-Reminder laufen zentral über notificationsService (Glocke) +
  // AppointmentReminderProvider (visuelles Popup). Der frühere zusätzliche
  // useAppointmentReminders()-Hook wurde entfernt, da er dieselben
  // Erinnerungen doppelt erzeugt hat.

  return (
    <div className="app-layout" style={{
      minHeight: '100vh',
      background: 'var(--bg-primary)',
      position: 'relative'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0.03,
        backgroundImage: `radial-gradient(circle at 20% 80%, var(--accent-primary) 0%, transparent 50%),
                          radial-gradient(circle at 80% 20%, var(--accent-secondary) 0%, transparent 50%)`,
        pointerEvents: 'none',
        zIndex: 0
      }} />

      {/* Sidebar */}
      {!isMobile && <SidebarAnimated />}

      {/* Main Content Area */}
      <div
        style={{
          marginLeft: 80, // Adjusted to match new collapsed sidebar width
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          zIndex: 1,
          transition: 'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          width: !isMobile ? 'calc(100% - 80px)' : 'calc(100% - 80px)',
          overflow: 'hidden'
        }}
      >
        {/* Header */}
        <Header />

        {/* Page Content */}
        <main style={{
          flex: 1,
          padding: 0,
          maxWidth: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
          overscrollBehavior: 'contain',
          WebkitOverflowScrolling: 'touch'
        }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              padding: '16px',
              minHeight: 'min-content'
            }}
          >
            <Outlet />
          </motion.div>
        </main>
      </div>

      {/* OCTA Messenger */}
      <MSNMessenger />

      {/* Mobile Bottom Navigation */}
      {isMobile && (
        <motion.div
          className="mobile-nav"
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            background: 'var(--bg-secondary)',
            borderTop: '1px solid var(--glass-border)',
            padding: 'var(--spacing-sm) 0',
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            zIndex: 1000,
            backdropFilter: 'blur(10px)'
          }}
        >
          {['📊', '👥', '📅', '💬', '⚙️'].map((icon, index) => (
            <button
              key={index}
              className="btn btn-ghost"
              style={{
                fontSize: '1.5rem',
                padding: 'var(--spacing-sm)'
              }}
            >
              {icon}
            </button>
          ))}
        </motion.div>
      )}
    </div>
  );
};